import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Layers3, Calendar, Briefcase, Wifi, ArrowRight } from "lucide-react";

const RYTHMES = [
  {
    icon: Calendar,
    name: "Initial",
    tagline: "Plein temps, immersion totale",
    desc:
      "Le format classique. Cours en présentiel à temps plein avec stages réguliers. Idéal pour les étudiants qui veulent s'immerger dans la vie de campus.",
    perks: ["Présentiel à temps plein", "Stages tous les ans", "Vie associative complète"],
  },
  {
    icon: Briefcase,
    name: "Alternance",
    tagline: "Salaire et expérience pendant les études",
    desc:
      "Alliez formation et expérience professionnelle dès la première année pour développer vos compétences et préparer efficacement votre avenir.",
    perks: ["Organisation flexible des études", "Acquisition de compétences opérationnelles", "Insertion professionnelle accélérée"],
  },
  {
    icon: Wifi,
    name: "E-learning",
    tagline: "Liberté géographique, exigence académique",
    desc:
      "Suivez nos programmes à distance, à votre rythme, avec un accompagnement personnalisé. Idéal pour les actifs et les étudiants internationaux.",
    perks: ["100% en ligne", "Sessions live + replay", "Tutorat individualisé"],
  },
];

export const RythmesFormation = () => {
  const navigate = useNavigate();
  return (
    <section
      id="rythmes"
      data-testid="rythmes-section"
      className="section-padding bg-[#FAF8F3]"
    >
      <div className="container-edge">
        <div className="max-w-3xl mb-14">
          <div className="overline mb-4 flex items-center gap-3">
            <Layers3 className="h-4 w-4" strokeWidth={1.6} />
            Rythmes de formation
          </div>
          <h2 className="font-display text-2xl sm:text-3xl md:text-5xl text-navy-700 leading-tight">
            Trois <em className="not-italic red-shine">rythmes</em>, un même niveau d'exigence.
          </h2>
          <p className="text-[#555] text-[16px] leading-relaxed mt-5">
            Chaque parcours est accessible dans le format qui vous correspond, mêmes diplômes, même exigence académique, même réseau Alumni.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-navy-100">
          {RYTHMES.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="bg-white p-8 md:p-10 group relative"
                data-testid={`rythme-${r.name.toLowerCase()}`}
              >
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-navy-500 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                <Icon className="h-9 w-9 text-navy-700 mb-6" strokeWidth={1.4} />
                <div className="overline mb-2 text-navy-500">{r.tagline}</div>
                <h3 className="font-display text-3xl text-navy-700 mb-4 leading-tight">{r.name}</h3>
                <p className="text-[#555] text-[14px] leading-relaxed mb-6">{r.desc}</p>
                <ul className="space-y-2 pt-5 border-t border-navy-100">
                  {r.perks.map((p) => (
                    <li key={p} className="flex gap-2.5 text-[13px] text-navy-700">
                      <span className="text-navy-500 font-bold leading-tight">+</span>
                      {p}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-wrap gap-4 items-center">
          <button onClick={() => navigate("/contact")} className="btn-red" data-testid="rythmes-cta">
            Discuter de mon projet
            <ArrowRight className="h-4 w-4" />
          </button>
          <p className="text-[13px] text-[#666]">
            Pas sûr du rythme idéal ? Faites le quiz d'orientation ci-dessous.
          </p>
        </div>
      </div>
    </section>
  );
};

export default RythmesFormation;
